<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :max-width="'1200'"
  >
    <v-card :loading="loading">
      <v-system-bar>
        <v-spacer/>
        <v-icon @click="close()" large>mdi-minus</v-icon>
      </v-system-bar>
      <v-card-text>
        <v-container>
          <v-row v-if="errors_exist">
            <v-col cols="12">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-tabs
              v-model="tab"
              centered
              icons-and-text
              background-color="primary"
              class="rounded-t-lg mt-4"
              dense
              dark
              grow
            >
              <v-tabs-slider/>
              <v-tab @click="tabChange(0)">
                Thông tin người dùng
                <v-icon>mdi-account</v-icon>
              </v-tab>
              <v-tab @click="tabChange(1)">
                Hỏi đáp kỹ thuật
                <v-icon>mdi-help</v-icon>
              </v-tab>
              <v-tab @click="tabChange(2)">
                Liên hệ - Phản hồi
                <v-icon>mdi-comment-quote-outline</v-icon>
              </v-tab>
              <v-tab-item class="mt-6">
                <v-row>
                  <v-col cols="12">
                    <label>Ảnh đại diện</label>
                    <input 
                      type="file" 
                      @change="onFilePicked" 
                      class="d-none"
                      ref="fileInput" 
                      accept="image/*"
                    />
                    <div class="text-center">
                      <v-avatar
                        size="150"
                        tile
                      >
                        <v-hover v-slot="{ hover }">
                          <v-img
                            v-if="avatar_url"
                            :src="avatar_url"
                            class="mx-auto"
                            @click="onPickFile"
                            width="150"
                          >
                            <div v-if="hover" class="avatar-icon-upload">
                              <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                            </div>
                          </v-img>
                          <v-img
                            v-else
                            src="@/assets/NoImage.jpg"
                            class="mx-auto"
                            @click="onPickFile"
                            width="150"
                          >
                            <div v-if="hover" class="avatar-icon-upload">
                              <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                            </div>
                          </v-img>
                        </v-hover>
                      </v-avatar>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.name"
                      label="Tên hiển thị"
                      class="require"
                      hide-details
                      autofocus
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.email"
                      label="Địa chỉ Email"
                      class="require"
                      hide-details
                      :disabled="item.id ? true : false"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="info.username"
                      label="Tên tài khoản"
                      class="require"
                      hide-details
                      :disabled="item.id ? true : false"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="info.so_dien_thoai"
                      label="Số điện thoại"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="info.dia_chi"
                      label="Địa chỉ"
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-row v-if="item.id != authMod.user.user.id">
                  <v-col>
                    <v-switch
                      v-model="isActive"
                      :label="isActive ? 'Hoạt động' : 'Khóa'"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="$role('supper-admin') || $role('so-nong-nghiep')">
                  <v-col cols="12">
                    <label>Vai trò:</label>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="auto"
                    class="mx-auto"
                    v-for="(role,index) in roles"
                    :key="index"
                  >
                    <v-checkbox
                      v-model="roleSelected"
                      :label="role.name"
                      :value="role.id"
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-row v-if="!item.id">
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.password"
                      label="Mật khẩu"
                      class="require"
                      hide-details
                      type="password"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="item.password_confirmation"
                      label="Nhập lại mật khẩu"
                      class="require"
                      hide-details
                      type="password"
                    />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12">
                    <v-btn 
                      block
                      @click="showDialogChangePassword"
                    >
                      <v-icon left>
                        mdi-key-change
                      </v-icon>
                      Đổi mật khẩu
                    </v-btn>
                    <ChangePassword 
                      :showDialog="dialogChangePassword" 
                      :item="itemChangePassword" 
                      @confirmed="onChangePasswordConfirmed" 
                      @cancelled="onChangePasswordCancelled"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="mt-6">
                <v-row>
                  <v-col cols="12">
                    <UserSupport/>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="mt-6">
                <v-row>
                  <v-col cols="12">
                    <UserContact/>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small v-if="tabIndex == 0"><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          v-if="tabIndex == 0"
          color="primary darken-1"
          text
          @click="saveChangePassword(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import ChangePassword from '@/views/auth/password/ChangePassword';
  import UserSupport from '@/views/user/UserSupport';
  import UserContact from '@/views/user/UserContact';
  import { mapState, mapActions } from 'vuex';
  export default {
    components: { 
      ChangePassword,
      UserSupport,
      UserContact
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        tab: 0,
        tabIndex: 0,
        avatar_url: null,
        dialog: false,
        errors_exist: false,
        errors: [],
        roles: [],
        roleSelected: [],
        dialogChangePassword: false,
        itemChangePassword: {},
        isActive: true,
        info: {}
      }
    },
    computed: {
      ...mapState([
        'authMod',
        'config'
      ])
    },
    watch: {
      showDialog() {
        const app = this
        app.dialog = false;
        app.errors_exist=false;
        if (app.showDialog) {
          app.dialog = true;
          app.getRoles()
          if(app.item.status && app.item.status.is_active=='0'){
            app.isActive=false;
          }
          if(app.item.info){
            app.info = app.item.info;
          }
          app.avatar_url = null;
          if(app.item.info && app.item.info.anh_dai_dien) {
            app.avatar_url = `${app.config.beUrl}/uploads/${app.item.info.anh_dai_dien}`;
          }
          app.roleSelected=[];
          if(app.item.roles){
            app.item.roles.forEach(function(v, i){
              app.roleSelected.push(v.id);
            })
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getRoles () {
        const app = this
        axios.get("api/v1/roles")
          .then(response => {
            app.roles = response.data;
          })
          .catch(function (error) {
            app.openSnackbar({ 
              type: 'warning',
              body: 'Chưa lấy được vai trò người dùng!'
            })
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      showDialogChangePassword(){
        this.itemChangePassword = {};
        this.dialogChangePassword = true;
      },
      onChangePasswordConfirmed(item) {
        this.dialogChangePassword = false;
      },
      onChangePasswordCancelled () {
        this.dialogChangePassword = false;
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/users`;
        let data = item;

        data.roles = app.roleSelected;
        data.is_active = app.isActive;
        data.user_info = app.info;
        
        if (data.id) {
          method = "patch";
          url = `api/v1/users/${data.id}`;
        }
        
        app.loading=true;
        
        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      tabChange(v){
        this.tabIndex = v;
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;

        const file = event.target.files[0];
        app.avatar_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        }

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.info.anh_dai_dien = response.data.filePath;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải lên hình ảnh thành công!'
            });
          })
          .catch(function (error) {
            app.avatar_url = null;
            app.openSnackbar({ type: 'error' });
          });
      },
    }
  }
</script>
<style>
  .avatar-icon-upload{
    position: absolute;
    background: gray;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    cursor: pointer;
  }
  .avatar-icon-upload .v-icon{
    font-size: 36px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>